export const cartSelector = (state) => {
  return state.persistShop.cart ?
      state.persistShop.cart : [];
};
